import { type FocusEvent, useState } from "react";

/**
 * Tracks whether focus is anywhere within a container. Spread `focusProps` onto
 * the container element and read `focused`.
 *
 * `focused` stays true while focus moves between the container's descendants —
 * the `relatedTarget` check means clicking a footer control (e.g. a Submit
 * button or checkbox) doesn't count as blurring the field. Used by the
 * submission comment inputs to keep their controls visible while interacting.
 */
export function useFocusWithin() {
  const [focused, setFocused] = useState(false);

  const focusProps = {
    onFocus: () => setFocused(true),
    onBlur: (event: FocusEvent) => {
      if (!event.currentTarget.contains(event.relatedTarget)) {
        setFocused(false);
      }
    },
  };

  return { focused, focusProps };
}
